import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const TimeZoneSelect = ({ value, onChange }) => {
  const { t } = useLanguage();

  // Список наиболее популярных часовых поясов (совместимый с Rails ActiveSupport::TimeZone)
  const timeZones = [
    { value: 'UTC', label: 'UTC (UTC+0)' },
    
    // Россия
    { value: 'Europe/Kaliningrad', label: 'Kaliningrad (UTC+2)' },
    { value: 'Europe/Moscow', label: 'Moscow (UTC+3)' },
    { value: 'Europe/Samara', label: 'Samara (UTC+4)' },
    { value: 'Asia/Yekaterinburg', label: 'Yekaterinburg (UTC+5)' },
    { value: 'Asia/Omsk', label: 'Omsk (UTC+6)' },
    { value: 'Asia/Krasnoyarsk', label: 'Krasnoyarsk (UTC+7)' },
    { value: 'Asia/Irkutsk', label: 'Irkutsk (UTC+8)' },
    { value: 'Asia/Yakutsk', label: 'Yakutsk (UTC+9)' },
    { value: 'Asia/Vladivostok', label: 'Vladivostok (UTC+10)' },
    { value: 'Asia/Magadan', label: 'Magadan (UTC+11)' },
    { value: 'Asia/Kamchatka', label: 'Kamchatka (UTC+12)' },
    
    // Европа
    { value: 'Europe/London', label: 'London (UTC+0)' },
    { value: 'Europe/Paris', label: 'Paris (UTC+1)' },
    { value: 'Europe/Berlin', label: 'Berlin (UTC+1)' },
    { value: 'Europe/Rome', label: 'Rome (UTC+1)' },
    { value: 'Europe/Madrid', label: 'Madrid (UTC+1)' },
    { value: 'Europe/Athens', label: 'Athens (UTC+2)' },
    { value: 'Europe/Helsinki', label: 'Helsinki (UTC+2)' },
    { value: 'Europe/Istanbul', label: 'Istanbul (UTC+3)' },
    { value: 'Europe/Kiev', label: 'Kyiv (UTC+2)' },
    { value: 'Europe/Minsk', label: 'Minsk (UTC+3)' },
    
    // Азия
    { value: 'Asia/Dubai', label: 'Dubai (UTC+4)' },
    { value: 'Asia/Karachi', label: 'Karachi (UTC+5)' },
    { value: 'Asia/Kolkata', label: 'Kolkata (UTC+5:30)' },
    { value: 'Asia/Dhaka', label: 'Dhaka (UTC+6)' },
    { value: 'Asia/Bangkok', label: 'Bangkok (UTC+7)' },
    { value: 'Asia/Singapore', label: 'Singapore (UTC+8)' },
    { value: 'Asia/Hong_Kong', label: 'Hong Kong (UTC+8)' },
    { value: 'Asia/Shanghai', label: 'Shanghai (UTC+8)' },
    { value: 'Asia/Tokyo', label: 'Tokyo (UTC+9)' },
    { value: 'Asia/Seoul', label: 'Seoul (UTC+9)' },
    
    // Австралия и Океания
    { value: 'Australia/Perth', label: 'Perth (UTC+8)' },
    { value: 'Australia/Sydney', label: 'Sydney (UTC+10/+11)' },
    { value: 'Australia/Melbourne', label: 'Melbourne (UTC+10/+11)' },
    { value: 'Pacific/Auckland', label: 'Auckland (UTC+12/+13)' },
    
    // Америка
    { value: 'America/New_York', label: 'New York (UTC-5/-4)' },
    { value: 'America/Chicago', label: 'Chicago (UTC-6/-5)' },
    { value: 'America/Denver', label: 'Denver (UTC-7/-6)' },
    { value: 'America/Los_Angeles', label: 'Los Angeles (UTC-8/-7)' },
    { value: 'America/Anchorage', label: 'Anchorage (UTC-9/-8)' },
    { value: 'Pacific/Honolulu', label: 'Honolulu (UTC-10)' },
    { value: 'America/Toronto', label: 'Toronto (UTC-5/-4)' },
    { value: 'America/Vancouver', label: 'Vancouver (UTC-8/-7)' },
    { value: 'America/Mexico_City', label: 'Mexico City (UTC-6/-5)' },
    { value: 'America/Sao_Paulo', label: 'São Paulo (UTC-3/-2)' },
    { value: 'America/Buenos_Aires', label: 'Buenos Aires (UTC-3)' },
    
    // Африка
    { value: 'Africa/Cairo', label: 'Cairo (UTC+2)' },
    { value: 'Africa/Johannesburg', label: 'Johannesburg (UTC+2)' },
    { value: 'Africa/Lagos', label: 'Lagos (UTC+1)' },
  ];

  // Сортируем по UTC offset
  const sortedTimeZones = [...timeZones].sort((a, b) => {
    const offsetA = parseInt(a.label.match(/UTC([+-]\d+)/)?.[1] || '0');
    const offsetB = parseInt(b.label.match(/UTC([+-]\d+)/)?.[1] || '0');
    return offsetA - offsetB;
  });

  return (
    <select
      value={value || 'UTC'}
      onChange={(e) => onChange(e.target.value)}
      className="form-select"
    >
      <option value="">{t('signup.selectTimeZone')}</option>
      {sortedTimeZones.map((tz) => (
        <option key={tz.value} value={tz.value}>
          {tz.label}
        </option>
      ))}
    </select>
  );
};

export default TimeZoneSelect;